import { Button } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { useTranslation } from "react-i18next";
import { useAuth } from "@context/AuthContext";

export function GoogleLoginButton() {
  const { t } = useTranslation();
  const { loginWithGoogle } = useAuth();

  return (
    <Button
      variant="outlined"
      size="large"
      startIcon={<GoogleIcon />}
      onClick={loginWithGoogle}
      sx={{
        py: 1.5,
        px: 4,
        fontSize: 16,
        borderColor: "divider",
        color: "text.primary",
        "&:hover": {
          borderColor: "primary.main",
          backgroundColor: "action.hover",
        },
      }}
    >
      {t("auth.signIn")}
    </Button>
  );
}
